import React, { useState } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { shape, object } from "prop-types";
import { collectionToStories } from "@quintype/components";
import "./partnered-engagement.m.css";

import { HeroSection } from "./hero-section";
import { InfoBoxes } from "./info-boxes";
import { ProprietaryResearchSection } from "./proprietary-research-section";
import { CoBrandedResearchSection } from "./co-branded-research-section";
import { SponsoredSessionsSection } from "./sponsored-sessions-section";
import { AdvertiseSection } from "./advertise-section";
import { PartnerForm } from "./partner-form";

export const PartneredEngagementPage = ({ data }) => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formType, setFormType] = useState("Partner with us");
  const homePageData = useSelector((state) => get(state, ["qt", "config", "publisher-attributes","homePageData"], {}));

  const openPartnerForm = (type = "Partner with us") => {
    setFormType(type);
    setIsFormOpen(true);
  };
  const closePartnerForm = () => setIsFormOpen(false);

  const collectionStories = data?.collection
    ? collectionToStories(data.collection)
    : [];

  return (
    <>
      <div className="page-container" styleName="partnered-engagement-page">
        <HeroSection onPartnerFormOpen={openPartnerForm} />
        <InfoBoxes />
        <ProprietaryResearchSection onPartnerFormOpen={openPartnerForm} />
        <CoBrandedResearchSection
          stories={collectionStories}
          onPartnerFormOpen={openPartnerForm}
        />
        <SponsoredSessionsSection onPartnerFormOpen={openPartnerForm} />
        <AdvertiseSection contactEmail={homePageData?.contactEmail} contactPhone={homePageData?.contactPhone} />
      </div>

      {isFormOpen && <PartnerForm onClose={closePartnerForm} formType={formType} />}
    </>
  );
};

PartneredEngagementPage.propTypes = {
  data: shape({
    collection: object,
  }),
};

export default PartneredEngagementPage;